/**
 * localStorage-backed save storage.
 *
 * Every access is wrapped: private browsing, disabled site data and quota
 * limits all throw here, and losing a session to an unhandled exception from a
 * storage read would be a worse bug than not saving at all.
 */
import type { SaveStorage } from '../sim/systems/SaveSystem.js';

export class BrowserStorage implements SaveStorage {
  read(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  write(key: string, value: string): void {
    // Deliberately allowed to throw: SaveSystem catches it and reports failure
    // to the player rather than silently pretending the save worked.
    window.localStorage.setItem(key, value);
  }

  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }

  keys(): string[] {
    try {
      return Object.keys(window.localStorage);
    } catch {
      return [];
    }
  }
}
